var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appWhite d-flex flex-column align-center justify-center rounded-lg ml-4 pa-4",staticStyle:{"height":"80px","width":"120px"}},[_c('app-text',{attrs:{"color":_vm.cardColor,"size":"xlarge-bold"}},[_vm._v(_vm._s(_vm.cardValue))]),_c('app-text',{attrs:{"color":_vm.cardColor,"size":"small"}},[_vm._v(_vm._s(_vm.cardLabel))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }